// Team names are unique per organisation: POST /teams upserts on (Name, OrgID), so a taken name would
// merge into the existing team instead of creating one. Case-insensitive, trimmed.
// One wording for the duplicate-name refusal: the form's own check and the server's 409.
export const TEAM_NAME_TAKEN_MESSAGE = 'A team with this name already exists';

export const isTeamNameTaken = (teams = [], name) => {
	const key = name?.trim().toLowerCase();
	return Boolean(key) && teams.some((team) => team.name?.trim().toLowerCase() === key);
};
